import { render, staticRenderFns } from "./orderToggle.vue?vue&type=template&id=4bd6d36c"
import script from "./orderToggle.js?vue&type=script&lang=js&external"
export * from "./orderToggle.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports